export enum FaseEnum {
  ADESAO_MUNICIPAL = 2,
  ADESAO_PROFISSIONAL = 4
}
